import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
    selector: 'plugin-template',
    templateUrl: 'plugin.component.html',
    styleUrls: [ 'plugin.component.scss' ]
})
export class PluginTemplate {

    /**
     * The element reference of the content template.
     */
    @ViewChild('content', { read: ViewContainerRef }) content: ViewContainerRef = null;

    /**
     * The injected modal data.
     */
    @Input() protected data: { [key: string]: any };

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/templates/plugin/plugin.component.ts